export const isError = (x: unknown) => x instanceof Error;
export const isString = (x: unknown) => typeof x === 'string';
export const isData = (x: unknown) => typeof x === 'object' && !isError(x);
